export const aboutTitle = "Hi, I'm Taalay, a passionate software engineer with a knack for crafting clean, efficient, and user-friendly solutions.";
export const aboutDescription = "I'm a self-taught developer with a strong foundation in mobile and web technologies. I specialize in building high-quality, scalable applications that deliver exceptional user experiences.";
export const experienceText = "Over the years I've gained valuable experience through freelancing and collaborations with diverse teams, startups, and organizations. Here's a snapshot of my journey:";

export const contacts = {
    email: "a.u.taalay@gmail.com",
    github: "https://github.com/TaalayDev",
    linkedin: "https://www.linkedin.com/in/taalaydev/",
    telegram: "https://t.me/taalay_dev",
};

export const experiences = [
    {
        title: "Freelancing",
        profession: "Android Developer, Web Development",
        date: "2018 - 2019"
    },
    {
        title: "One-Team company",
        profession: "Android Developer, Cofounder",
        date: "2019 - 2021"
    },
    {
        title: "Oracle Digital",
        profession: "Flutter Developer (Remotely Contract)",
        date: "2021 - 2022"
    },
    {
        title: "ItAdis",
        profession: "Lead Flutter and Android Developer",
        date: "2022 January - 2022 September"
    },
    {
        title: "Oracle Digital",
        profession: "Lead Flutter and Android Developer",
        date: "2022 September - 2024 February"
    },
    {
        title: "Peacky Group",
        profession: "Android Developer",
        date: "2024 March - 2024 May"
    },
    {
        title: "Peacky Group",
        profession: "iOS, MacOS Developer",
        date: "2024 May - 2024 September"
    },
]

export const skils = [
    { name: "Android", langs: ["Java", "Kotlin"], percent: 85 },
    { name: "Flutter", langs: ["Dart"], percent: 95 },
    { name: "Backend", langs: ["PHP", "Laravel"], percent: 70 },
    { name: "Web", langs: ["Javasript", "React", "Vue"], percent: 60 },
    { name: "iOS, MacOS", langs: ["Swift"], percent: 40 },
];

export const projects = [
    {
        name: "Picell",
        image: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/cd/d9/5d/cdd95da0-3264-e530-dada-5564a963daf0/Placeholder.mill/360x360bb.png",
        platforms: {
            ios: "https://apps.apple.com/us/app/pixel-verse/id6736886514",
            macos: "https://apps.apple.com/us/app/pixel-verse/id6736886514",
            web: "https://taalaydev.github.io/pixelverse/",
            sourcecode: "https://github.com/TaalayDev/PixelVerse",
        },
        stack: ["Flutter"],
        description: "A Feature-Rich Pixel Art Creation Tool",
        note: [
            "Intuitive Drawing Tools: Pencil, brush, eraser, and more for precise pixel manipulation.",
            "Advanced Shape Tools: Easily create lines, rectangles, and circles.",
            "Color Management: Use the eyedropper tool and custom color palettes for perfect color selection.",
            "Layer Support: Create complex artwork with multiple layers.",
            "Selection and Transform: Select, move, and transform parts of your artwork.",
            "Mirror Drawing: Create symmetrical art effortlessly.",
            "Undo/Redo: Easily correct mistakes or revert changes.",
            "Zoom and Pan: Get up close and personal with your artwork.",
            "Animation Support: Create simple animations with frame management.",
            "Export Options: Save your work in various formats, including image and project files."
        ],
    },
    {
        name: "Doodle Verse",
        image: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/09/e9/dc/09e9dc22-f8e5-0b5b-44e8-6d50bcf1eaf8/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/360x360ia.png",
        platforms: {
            ios: "https://apps.apple.com/us/app/doodleverse-drawing-lessons/id6738771454",
            web: "https://taalaydev.github.io/doodleverse/",
            sourcecode: "https://github.com/TaalayDev/DoodleVerse-ComposeMultiplatform",
        },
        stack: ["Kotlin Multiplatform", "Jetpack Compose"],
        description: "Cross-platform digital drawing application built with Kotlin Multiplatform and Jetpack Compose. ",
        note: [
            "Cross-platform support: Runs on Android, iOS, Web, and Desktop.",
            "Multiple brush types: Including pencil, marker, watercolor, and various creative brushes.",
            "Shape tools: Rectangle, circle, line, arrow, ellipse, and polygon.",
            "Layer support: Create, manage, and organize your artwork in layers.",
            "Color picker: Advanced color selection with opacity control.",
            "Undo/Redo functionality: Easily correct mistakes or revisit previous states.",
            "Project management: Create, save, and edit multiple projects.",
            "Customizable canvas size: Choose from preset sizes or create custom dimensions."
        ],
    },
    {
        name: "Tsuzuki Connect",
        image: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/86/0d/78/860d78f5-202b-49d2-9ff2-7d3c27a67936/Placeholder.mill/360x360bb.png",
        platforms: {
            ios: "https://apps.apple.com/us/app/tsuzuki-connect/id6744872822",
            macos: "https://apps.apple.com/us/app/tsuzuki-connect/id6744872822",
            sourcecode: "https://github.com/TaalayDev/tsuzuki_connect",
        },
        stack: ["Flutter"],
        description: "A Japanese language learning adventure in the form of an interactive visual novel, built with Flutter.",
        note: [
            "Interactive visual novel: Engage with a captivating story while learning Japanese.",
            "Language lessons: Learn vocabulary, grammar, and pronunciation through immersive gameplay.",
            "Quizzes and challenges: Test your knowledge and track your progress.",
            "Offline access: Enjoy the app without an internet connection.",
        ],
    },
    {
        "name": "Constellation Catcher",
        "image": "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/ad/2f/d4/ad2fd423-dbdb-f429-30d9-6166b3721f61/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/360x360ia.png",
        "platforms": {
            "ios": "https://apps.apple.com/us/app/constellation-catcher/id6739852690",
            "macos": "https://apps.apple.com/us/app/constellation-catcher/id6739852690",
            "sourcecode": "https://github.com/TaalayDev/constellation_catcher",
        },
        "stack": ["Flutter"],
        "description": "Constellation Catcher is an educational app that helps users learn about constellations. Users can explore the night sky, view detailed information about constellations, and take quizzes to test their knowledge.",
        "note": [
            "Interactive sky map: Explore the night sky and learn about different constellations.",
            "Constellation details: View information about each constellation, including stars, mythology, and more.",
            "Offline access: Access content and quizzes offline.",
        ],
    },
    {
        "name": "Dialogue With The Monster",
        "image": "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/fc/e5/03/fce5036a-c153-9a3c-517e-cd5d24b2fa92/AppIcon-0-0-1x_U007emarketing-0-11-0-85-220.png/360x360ia.png",
        "platforms": {
            "ios": "https://apps.apple.com/us/app/dialogue-with-the-monster/id6754234905",
            "macos": "https://apps.apple.com/us/app/dialogue-with-the-monster/id6754234905",
        },
        "stack": ["Flutter"],
        "description": "Conversation-Driven Horror: Your words are your only tools in this battle of minds and wills",
        "note": [
            "Psychological Thriller: Immerse yourself in a suspenseful atmosphere where every choice matters.",
            "Dynamic Narrative: A branching storyline that adapts to your decisions and dialogue choices.",
            "Mystery and Intrigue: Uncover the secrets behind the monster's appearance and motives.",
            "Multiple Endings: Your journey can conclude in various ways depending on your actions and words.",
        ],
    },
    {
        "name": "The Answer is Yes",
        "image": "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/4d/35/53/4d35534f-23c1-2309-6ee5-824e25005f53/Placeholder.mill/360x360bb.png",
        "platforms": {
            "ios": "https://apps.apple.com/us/app/the-answer-is-yes/id6760308425",
            "macos": "https://apps.apple.com/us/app/the-answer-is-yes/id6760308425",
        },
        "stack": ["Flutter", "JavaScript"],
        "description": "You have been scheduled for an intake appointment.",
        "note": [
        ],
    },
    {
        "name": "Love Me? YES",
        "image": "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/3a/e8/f2/3ae8f2fc-11d1-dc52-c935-176cbb8f26da/Placeholder.mill/360x360bb.png",
        "platforms": {
            "ios": "https://apps.apple.com/us/app/love-me-yes/id6777530857",
            "macos": "https://apps.apple.com/us/app/love-me-yes/id6777530857",
        },
        "stack": ["Flutter", "JavaScript"],
        "description": "Love Me? Yes is a choice-driven visual novel that starts soft, personal, and almost comforting. Just a conversation, one reply at a time.",
        "note": [
            "Choice-Driven Narrative: Your decisions shape the story and your relationship with the character.",
            "Multiple Endings: Your journey can conclude in various ways depending on your actions and words.",
        ],
    },
    {
        "name": "While You're Here",
        "image": "https://img.itch.zone/aW1nLzI0NzY4NTEwLmpwZw==/315x250%23c/Qxprbq.jpg",
        "platforms": {
            "windows": "https://taalaydev.itch.io/while-youre-here"
        },
        "stack": ["HTML", "JavaScript"],
        "description": "An intimate visual novel where you navigate the quiet intensity of a developing relationship through heartfelt conversation and shared memories.",
        "note": [
            "Choice-Driven Narrative: Your decisions shape the story and your relationship with the character.",
            "Multiple Endings: Your journey can conclude in various ways depending on your actions and words.",
        ],
    },
    {
        "name": "Picell 3D",
        "image": "https://img.itch.zone/aW1nLzI2MzQ5ODY1LmpwZw==/315x250%23c/lGjukk.jpg",
        "platforms": {
            "windows": "https://taalaydev.itch.io/picell-3d"
        },
        "stack": ["Flutter"],
        "description": "Draw it in 2D. It's already 3D.",
        "note": [
            "Draw 2D images",
            "Watch them come alive in 3D",
            "Relaxing and satisfying gameplay",
            "Suitable for all ages",
        ],
    }

];